import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CART_URL = 'https://bienestardigital.click/cart/add?id=43120004464729&quantity=1';
export function StickyMobileCTA() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-2xl p-4" data-id="element-202">
      <a href={CART_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-brand-pink-600 text-white font-bold py-4 px-6 rounded-full shadow-lg hover:bg-brand-pink-700 hover:scale-[1.02] active:scale-[0.98] transition-all" data-id="element-203">
        QUIERO EMPEZAR AHORA
        <ArrowRightIcon className="w-5 h-5" data-id="element-204" />
      </a>
      <p className="text-center text-xs text-gray-600 mt-2" data-id="element-205">desde $16.990</p>
    </div>;
}